// 测试接入urt
import {EndPoint} from '@threegene/common-js/common';
import urt, {PROJECT_SIGN, urtTools} from '@threegene/user-research-tools/web/index';

export default function (Vue, router) {
  if (EndPoint.isXDM || EndPoint.isXCX) {
    const _pro = EndPoint.isXDM ? PROJECT_SIGN.XDM_APP : PROJECT_SIGN.XDM_MP;
    Vue.use(urt, {
      _isPro: process.env['HOST'] === 'prod', // 是否生产环境
      _pro, // 项目标识
      _route: router, // 路由，非必填(vue项目必填)
      _frontService: 'yeemiao-assess-html' // 当前服务名
    });
  }
}

export function urtLogin(userId) {
  try {
    if (EndPoint.isXDM || EndPoint.isXCX) urtTools.login({userId});
  } catch (error) {
    console.log(error);
  }
}



// WEBPACK FOOTER //
// ./src/js/util/urt/index.js